import {Component, OnInit, ViewChild} from '@angular/core';
import {DataTableDirective} from "angular-datatables";
import {TypeProductService} from "../../services/type-product.service";
import {first} from "rxjs/operators";

declare var swal: any;

@Component({
  selector: 'app-brand-type-products',
  templateUrl: './brand-type-products.component.html',
  styleUrls: ['./brand-type-products.component.scss']
})
export class BrandTypeProductsComponent implements OnInit {

    dtOptions: DataTables.Settings = {};
    type_products: any[];
    group_brands: any = [];

    @ViewChild(DataTableDirective) private dtElement;

    constructor(
        private typeProductService: TypeProductService,
    ) { }

    ngOnInit(): void {
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10,
            serverSide: true,
            processing: true,
            ajax: (dataTablesParameters: any, callback) => {
                this.typeProductService.getDatatable(dataTablesParameters)
                    .pipe(first())
                    .subscribe(response => {
                        this.type_products = response.data;
                        response.data.forEach(value => {
                            if (value.brands) {
                                this.group_brands.push(value.brands);
                            }
                        })
                        callback({
                            recordsTotal: response.recordsTotal,
                            recordsFiltered: response.recordsFiltered,
                            data: []
                        });
                    });
            },
            columns: [
                {data: 'name'},
                {data: 'brand_name'},
            ]
        };

    }

    private async reloadTable() {
        let dtIntance = await this.dtElement.dtInstance;
        dtIntance.ajax.reload();
    }

    delete(item: any): void {
        swal.fire({
            title: '¿Estás seguro que deseas eliminar este registro?',
            showCancelButton: true,
            confirmButtonText: 'Si, elimínalo!',
            showLoaderOnConfirm: true,
            preConfirm: (arg) => {
                return this.typeProductService.delete(item.id)
                    .pipe(first())
                    .subscribe(response => {
                        swal.fire({
                            title: 'Elemento eliminado con éxito',
                            type: 'success'
                        });
                        this.reloadTable();
                    }, error => {
                        swal.fire({
                            title: error,
                            type: 'error'
                        });
                        return error;
                    });
            },
            allowOutsideClick: () => !swal.isLoading()
        }).then((result) => {
        });
    }
}
